<template>
  <v-app-bar
    id="core-toolbar"
    app
    text
    style="background: #eee; border-radius: 0;"
  >
    <div class="v-toolbar-title">
      <v-toolbar-title
        class="tertiary--text font-weight-light menuadmin"
      >
        <v-btn
          v-if="responsive"
          class="default v-btn--simple"
          dark
          icon
          @click.stop="onClickBtn"
        >
          <v-icon>mdi-view-list</v-icon>
        </v-btn>
        {{ title }}
      </v-toolbar-title>
    </div>

    <v-spacer />
    <v-toolbar-items class="adminbtns">
      <v-flex
        align-center
        layout
        py-2
      >
        <router-link
          v-ripple
          class="v-btn"
          to="/"
        >
          <v-icon color="secondary">mdi-eye</v-icon>
        </router-link>
        <v-btn
          v-ripple
          text
          class="toolbar-items"
          @click="logout()"
        >
          <v-icon color="secondary">mdi-logout</v-icon>
        </v-btn>
      </v-flex>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>

import { auth } from '@/plugins/firebase'
import {
  mapMutations,
  mapGetters
} from 'vuex'

export default {
  data: () => ({
    title: null,
    responsive: false
  }),
  computed: {
    ...mapGetters({
      user: 'user'
    })
  },
  watch: {
    '$route' (val) {
      this.title = val.name
    }
  },
  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onClickBtn () {
      this.setDrawer(!this.$store.state.app.drawer)
    },
    onClick () {
      //
    },
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
      } else {
        this.responsive = false
      }
    },
    logout () {
      auth.signOut()
        .then(data => {
          this.$router.replace({ name: 'Connexion' })
        })
    }
  }
}
</script>

<style lang='scss'>
  .menuadmin{
    @media screen and (max-width: 550px) {
      position: absolute;
      left: 5px;
      top: 0;
    }
  }
  .adminbtns{
    position: absolute;
    right: 0;
    top: 5px;
  }
  #core-toolbar a {
    text-decoration: none;
  }

  .v-toolbar__items.principal{
    @media screen and (max-width: 550px) {
      position: absolute !important;
      top: 10px !important;
      right: 1em;
    }
  }
</style>
